module.exports = __webpack_public_path__ + "static/media/luminaria.7d8ec824.webp";